import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import PrivateHeader from 'containers/parts/PrivateHeader';
import { mappedProps } from 'containers/student/StudyUnit';
import SiteMain from 'containers/parts/SiteMain';
import classNames from 'classnames';
import CorrectAnswerCount from './common/CorrectAnswerCount';

const StudyUnit: React.FC<mappedProps> = (props: mappedProps) => {
  const { unit_id } = useParams<{unit_id: string}>();
  const [showHint, setShowHint] = useState(false);
  const [disableDownload, setDisableDownload] = useState(false);
  // 2026-03 追加 英語リーディングのトピックリスト注釈の共通文言
  const anotation_head = (
    <>
      以下の組み合わせは同じ英文で、問い方が異なります。英問英答から始めてわからなかったら和問和答で確認しましょう。
      <br />
    </>
  );

  useEffect(() => {
    if (unit_id) {
      props.fetchData(Number(unit_id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unit_id]);

  useEffect(() => {
    props.fetchStudyAchievementsLatest();
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  , []);


  const page = props.getRecord(Number(unit_id))

  const downloadPdf = (topicId: number) => {

    props.fetchContentData(topicId);
    setDisableDownload(true);
  };
  const studyTopic = props.student.studyTopic.record;

  useEffect(() => {
    const curriculumCodesArray =
      studyTopic &&
      studyTopic.contents.map(
        (content) => content.launch_parameters.curriculum_code,
      );
    if (
      curriculumCodesArray &&
      curriculumCodesArray.length > 0 &&
      disableDownload
    ) {
      props.pdfDownload(curriculumCodesArray)
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studyTopic/* , disableDownload */]);

  const downloadAllPdf = () => {
    //まずは全トピックを取得する必要がある
    const allTopicIds = page && page.topics.map((topic) => topic.id);
    if (allTopicIds) {
      props.downloadAllTopicsPdf(allTopicIds);
    }
  }
  
  return (
    <React.Fragment>
      <PrivateHeader />
      <SiteMain>
        <ol className="breadcrumbs">
          <li className="breadcrumbs__item">
            <Link to='/' className="breadcrumbs__link">マイページ</Link>
          </li>
          {
            page &&
            <React.Fragment>
              <li className="breadcrumbs__item">
                <Link to={`/study/${page.curriculum.id}`} className="breadcrumbs__link">
                  { page.curriculum.name }
                </Link>
              </li>
              <li className="breadcrumbs__item">
                <Link to={`/study/courses/${page.course.id}`} className="breadcrumbs__link">
                  { page.course.name }
                </Link>
              </li>
              <li className="breadcrumbs__item">
                { page.unit.name }
              </li>
            </React.Fragment>
          }
        </ol>

        {
          page &&

          <div className="site-main__main-contents">
            <div  className="page-title">
            <div className="page-title__left">
              { page.curriculum.name }
              &nbsp;
              <div className="page-title__badge">
                { page.course.name }
              </div>
                &nbsp;
                { page.unit.name }
              </div>
              <div className="page-title__correct-count">
                {props.student.studyAchievementsLatest.record && <>
                  <CorrectAnswerCount correctAnswerCount={props.student.studyAchievementsLatest.record.study_achievements.consecutive_correct_answer_count}/>
                </>}
              </div>
            </div>

            {
              page.curriculum.al_engine_connected &&
              <div className="suggestion-box">
                AIがおすすめするカリキュラムを進めていくとテストの受講が可能です。
                「<Link to={`/recommends/${page.curriculum.id}`} className="">もっともおすすめ学習</Link>」からご確認ください。
              </div>
            }

            <div className="topic-list">
              <div className="topic-list__head">
                <div className="topic-list__title">
                  “{ page.unit.name }”のトピック
                </div>
                {
                  page.curriculum.al_engine_connected &&
                  <div className="topic-list__head-note">
                    <div
                      onClick={() => setShowHint(!showHint)}
                      className="">
                      AI理解度判定について
                    </div>

                    <div
                      className={classNames("balloon topic-list__balloon", { 'is-active': showHint })}>
                      <div
                        onClick={() => setShowHint(false)}
                        className="balloon__close">
                        説明を閉じる
                      </div>
                      <div className="balloon__title">
                        AI理解度判定とは？
                      </div>
                      <div className="balloon__lead">
                        AI理解度判定とは、それぞれのトピックについてどの程度理解をしているのかを、AIが判定した結果です。
                      </div>
                      <dl className="balloon__list">
                        <dt className="balloon__list-title">
                          コンプリート
                        </dt>
                        <dd className="balloon__list-body">
                          教科書や大学入学共通テストのレベルに対して十分な理解度に達している。
                        </dd>
                        <dt className="balloon__list-title">
                          レベル３
                        </dt>
                        <dd className="balloon__list-body">
                          教科書や大学入学共通テストのレベルに対して７０％以上９５％未満の理解度。
                        </dd>
                        <dt className="balloon__list-title">
                          レベル２
                        </dt>
                        <dd className="balloon__list-body">
                          教科書や大学入学共通テストのレベルに対して５０％以上７０％未満の理解度。
                        </dd>
                        <dt className="balloon__list-title">
                          レベル１
                        </dt>
                        <dd className="balloon__list-body">
                          教科書や大学入学共通テストのレベルに対して５０％未満の理解度。
                        </dd>
                      </dl>
                    </div>
                  </div>
                }
                {
                  !page.curriculum.al_engine_connected &&
                  <div className="topic-list__head-note">
                    <div
                      onClick={() => setShowHint(!showHint)}
                      className="">
                      学習状況とは？
                    </div>

                    <div
                      className={classNames("balloon topic-list__balloon", { 'is-active': showHint })}>
                      <div
                        onClick={() => setShowHint(false)}
                        className="balloon__close">
                        説明を閉じる
                      </div>
                      <div className="balloon__title">
                        学習状況とは？
                      </div>
                      <div className="balloon__lead">
                        それぞれのコンテンツについて、学習進捗を表記しています。
                      </div>
                      <dl className="balloon__list">
                        <dt className="balloon__list-title">
                          学習終了
                        </dt>
                        <dd className="balloon__list-body">
                          コンテンツの教材の学習を終了しています。
                        </dd>
                        <dt className="balloon__list-title">
                          学習中
                        </dt>
                        <dd className="balloon__list-body">
                          コンテンツの教材の学習を開始し、学習中です。
                        </dd>
                        <dt className="balloon__list-title">
                          未学習
                        </dt>
                        <dd className="balloon__list-body">
                          コンテンツの教材の学習を開始していません。
                        </dd>
                      </dl>
                    </div>
                  </div>
                  }
                  
                  {/* 2026 03 追加 */}

                  {
                    // MARK: 教科：英語 ：リーディング：高１・自然科学
                    page.curriculum.id === 2 && page.unit.id === 394 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                          {anotation_head}
                          001-005、002-006、003-007、004-008、009-013、010-014、011-015、012-016、017-021、018-022、019-023、020-024、025-029、026-030、027-031、028-032
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高１・社会・生活
                    page.curriculum.id === 2 && page.unit.id === 395 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                          {anotation_head}
                          033-037、034-038、035-039、036-040、041-045、042-046、043-047、044-048、049-053、050-054、051-055、052-056
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高１・人文
                    page.curriculum.id === 2 && page.unit.id === 396 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                          {anotation_head}
                          057-061、058-062、059-063、060-064、065-069、066-070、067-071、068-072、073-077、074-078、075-079、076-080、081-085、082-086、083-087、084-088
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高１・物語・小説・エッセイ
                    page.curriculum.id === 2 && page.unit.id === 397 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          089-093、090-094、091-095、092-096、097-101、098-102、099-103、100-104
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高２・自然科学
                    page.curriculum.id === 2 && page.unit.id === 398 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          105-108、106-109、107-110、111-112、113-116、114-117、115-118、119-120、121-124、122-125、123-126、127-128、129-132、130-133、131-134、135-136
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高２・社会・生活
                    page.curriculum.id === 2 && page.unit.id === 399 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          137-140、138-141、139-142、143-144、145-148、146-149、147-150、151-152、153-156、154-157、155-158、159-160、161-164、162-165、163-166、167-168
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高２・人文
                    page.curriculum.id === 2 && page.unit.id === 400 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          169-172、170-173、171-174、175-176 、177-180、178-181、179-182、183-184、185-188、186-189、187-190、191-192、193-196、194-197、195-198、199-200
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高２・物語・小説・エッセイ
                    page.curriculum.id === 2 && page.unit.id === 401 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          201-205、202-206、203-207、204-208
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高３・自然科学
                    page.curriculum.id === 2 && page.unit.id === 402 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          209-215、210-216、211-217、212-213-214-218-219-220
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高３・社会・生活
                    page.curriculum.id === 2 && page.unit.id === 403 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          221-224、222-225、223-226、227-228
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高３・人文
                    page.curriculum.id === 2 && page.unit.id === 404 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          229-233、230-234、231-235、232-236
                      </p>
                    </div>
                  }
                  {
                    // MARK: 教科：英語 ：リーディング：高３・物語・小説・エッセイ
                    page.curriculum.id === 2 && page.unit.id === 405 &&
                    <div className="entrust-topic-additional-info">
                      <p>
                        {anotation_head}
                          237-241、238-242、239-243、240-244、245-249、246-250、247-251、248-252
                      </p>
                    </div>
                  }

              </div>
              <div className="topic-list__pdf-download-button topic-list__pdf-download-button--all">
                {page.topics.some((x) => x.pdf_ready === true) &&
                  <button
                    className="pdf-download-button"
                    onClick={downloadAllPdf}>
                    まとめてダウンロード (PDF)
                    <div className="pdf-download-button__icon" />
                  </button>}
              </div>
              <div className="topic-list__body">

                {
                  page.topics.map((topic, index) => (
                    <div key={index} className="topic-list__item">
                      <Link to={`/study/topics/${topic.id}`} className="topic-list__topic-name">
                        { topic.title }
                      </Link>
                      <div className="topic-list__phase-container">
                      {
                        topic.check_level &&
                        <div className="topic-list__phase">
                          AI理解度判定
                          <div className={classNames("topic-list__level", {  "topic-list__level--complete" : topic.check_level === 'コンプリート' })}>
                            { topic.check_level }
                          </div>
                        </div>
                      }
                      {
                        topic.status &&
                        <div className="topic-list__phase">
                          学習状況
                          <div className={classNames("topic-list__level", {  "topic-list__level--complete" : topic.status === 'complete' })}>
                            { topic.status === 'none' && '未学習' }
                            { topic.status === 'progress' && '学習中' }
                            { topic.status === 'complete' && '学習終了' }
                          </div>
                        </div>
                      }
                      { topic.pdf_ready &&
                        <div className="topic-list__pdf-download-button">
                          <button
                            disabled={!topic.pdf_ready}
                            onClick={()=> downloadPdf(topic.id)}
                            className="pdf-download-button">
                            PDF
                            <div className="pdf-download-button__icon" />
                          </button>
                        </div>
                      }
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
            <div className="back-home">
              <Link to='/' className="back-home__link">マイページへ戻る</Link>
            </div>
          </div>
        }

        <ol className="breadcrumbs">
          <li className="breadcrumbs__item">
            <Link to='/' className="breadcrumbs__link">マイページ</Link>
          </li>
          {
            page &&
            <React.Fragment>
              <li className="breadcrumbs__item">
                <Link to={`/study/${page.curriculum.id}`} className="breadcrumbs__link">
                  { page.curriculum.name }
                </Link>
              </li>
              <li className="breadcrumbs__item">
                <Link to={`/study/courses/${page.course.id}`} className="breadcrumbs__link">
                  { page.course.name }
                </Link>
              </li>
              <li className="breadcrumbs__item">
                { page.unit.name }
              </li>
            </React.Fragment>
          }
        </ol>
      </SiteMain>
    </React.Fragment>
  );
}

export default StudyUnit